import Notify from 'quasar/src/plugins/Notify.js';

// Receita de toast — ver STYLE_GUIDE.md seção 4. `vp-notify` é global e de nome único: o Notify é teleportado (regra 6).
const NOTIFY_CLASSES = 'vp-notify tw-font-inter tw-rounded-xl tw-shadow-[0_16px_48px_-16px_rgba(23,105,182,0.25)]'

const VARIANTS = {
  success: { title: 'Sucesso', icon: 'mdi-check-circle-outline', color: 'positive', textColor: 'dark' },
  warning: { title: 'Atenção', icon: 'mdi-alert-outline', color: 'warning', textColor: 'dark' },
  error: { title: 'Erro', icon: 'mdi-alert-circle-outline', color: 'negative', textColor: 'white' }
}

const notify = (variant, message, { actions = [], ...options } = {}) => {
  const { title, icon, color, textColor } = VARIANTS[variant]

  return Notify.create({
    message: title,
    caption: message,
    icon,
    color,
    textColor,
    position: 'bottom',
    multiLine: false,
    classes: NOTIFY_CLASSES,
    actions: [
      ...actions.map((action) => ({ color: textColor, ...action })),
      { icon: 'mdi-close', color: textColor, flat: true, round: true, dense: true }
    ],
    progress: true,
    ...options
  })
}

export const notifySuccess = (message, options) => notify('success', message, options)
export const notifyWarning = (message, options) => notify('warning', message, options)
export const notifyError = (message, options) => notify('error', message, options)
